// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2023-05-07 17:13:59 +0200 (Sun, 07 May 2023) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 134540 $
//  Purpose   : backend header (L131Split layout)
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Menu, Breadcrumb, Image} from 'semantic-ui-react'

// ---Framework imports
import {Link, PortalTarget, VIcon} from 'uix/components'
import {useRouter, useActions, useEffect, useSelector} from 'uix/hooks'
import {UserMenuItem} from 'uix/auth/components'
import {QuickSearchInput} from 'uix/modules/search/components'
import {Sel} from 'uix/registries'

// ---Local imports
import './header.scss'

// ---Globals
const ClassTabPath = ({}) => {
  let {request} = useRouter()
  if (request.classname != 'test') return null
  let {classname, tabname} = request
  return (
    <>
      <Breadcrumb.Divider icon="right angle" />
      <Breadcrumb.Section>
        <Link classname={classname}>{classname}</Link>
      </Breadcrumb.Section>
      <Breadcrumb.Divider icon="right angle" />
      <Breadcrumb.Section>{request.tabname}</Breadcrumb.Section>
    </>
  )
}

const customLink = node => {
  // maybe jobs should implement tree/id
  if (node.datatype == 20) {
    if (node.subtype == 2) {
      return {classname: 'import', tabname: 'package'}
    } else if (node.subtype == 1) {
      return {classname: 'job', tabname: 'id'}
    } else {
      return {classname: 'job', tabname: 'list', id: null}
    }
  } else {
    return {}
  }
}

export const AdminHeader = ({}) => {
  let mountPortal = useActions('mountPortal')
  let apiurl = useSelector(Sel.apiurl)
  let url = apiurl.href(`/favicon.ico`)

  //XXX: this TabMenuPortal stuff looks fishy
  useEffect(() => {
    return () => mountPortal({TabMenuPortal: false})
  }, [])
  return (
    <Menu size="large" borderless>
      <Menu.Item>
        <Image src={url} style={{height: '2rem'}} />
      </Menu.Item>
      <PortalTarget id="topPortal" />
      <Menu.Item position="right" style={{width: '15vw'}}>
        <VIcon name="search" />
        <QuickSearchInput fluid />
      </Menu.Item>
      <UserMenuItem />
      <Menu.Item fitted id="TabMenuPortal" ref={() => mountPortal({TabMenuPortal: true})} />
    </Menu>
  )
}
